import {leadStatusTypes, leadActionKeys} from './leadStatus';
import {SequenceTypes, templateTypes} from './sequenceStages';

export const messageFields = {
    SUBJECT: "SUBJECT",
    CC: "CC",
    TEXT: "TEXT",
    ATTACHMENTS: "ATTACHMENTS"
};

export const tasksActionsBySeqType = {
    [SequenceTypes.EMAIL.name]: {
        [leadStatusTypes.ASSIGNED_TO_REP]: [
            templateTypes.HANDOVER,
            {actionKey: leadActionKeys.MARK_AS_WON, name: 'Stop Follow Up', displayName: 'Stop Follow Up', borderClassName: 'border-assigned'},
            templateTypes.LOOP_BACK_IN,
            templateTypes.CALL_ME,
        ],
        [leadStatusTypes.ENGAGED]: [
            templateTypes.ENGAGED,
        ],
        [leadStatusTypes.ENDED]: [
            templateTypes.NOT_INTERESTED,
            templateTypes.LEAD_NOT_FIT,
            templateTypes.WRONG_PERSON,
            templateTypes.EXISTING_CUSTOMER,
            templateTypes.EXISTING_PROSPECT,
            templateTypes.LEAD_OPTED_OUT,
        ],
        "OTHER ACTIONS": [
            {actionKey: leadActionKeys.FOLLOWUP, name: 'Follow Up', displayName: 'Contact Later'},
            {actionKey: leadActionKeys.OOO, name: 'Out Of Office', displayName: 'Out Of Office'},
        ],
    },
    [SequenceTypes.CHAT.name]: {
        [leadStatusTypes.ASSIGNED_TO_REP]: [
            templateTypes.HANDOVER,
        ],
        [leadStatusTypes.ENDED]: [
            templateTypes.NOT_INTERESTED,
            templateTypes.LEAD_NOT_FIT,
        ],
    }
};

export const actionTypes = {
    TEMPLATE: 'TEMPLATE',
};
